import React from "react";
import AnchorTag from "./anchor";

export default {
  h1: props => (
    <h1 className="heading1" id={props.children.replace(/\s+/g, "").toLowerCase()} {...props} />
  ),
  h2: props => (
    <h2 className="heading2" id={props.children.replace(/\s+/g, "").toLowerCase()} {...props} />
  ),
  h3: props => (
    <h3 className="heading3" id={props.children.replace(/\s+/g, "").toLowerCase()} {...props} />
  ),
  h4: props => (
    <h4 className="heading4" id={props.children.replace(/\s+/g, "").toLowerCase()} {...props} />
  ),
  h5: props => (
    <h5 className="heading5" id={props.children.replace(/\s+/g, "").toLowerCase()} {...props} />
  ),
  h6: props => (
    <h6 className="heading6" id={props.children.replace(/\s+/g, "").toLowerCase()} {...props} />
  ),
  p: props => <p className="paragraph" {...props} />,
  a: AnchorTag,
  blockquote: props => <BlockQuote {...props} />,
  // TODO add `img`
  // TODO add `blockquote`
  // TODO add `ul`
  // TODO add `li`
  // TODO add `table`
  table: props => <div className="container-fluid mt-3 mb-3" {...props} />,
  thead: props => <TableHead {...props} />,
  tbody: props => <div className="container-fluid" {...props} />,
  th: props => <TableHeader {...props} />,
  td: props => <TableElement {...props} />,
  tr: props => <div className="row" {...props} />
};


const TableElement = props => {
  let { align } = props;

  return (<div className={`col-2 text-${align}`}>
    <div {...props} />
  </div>);
};

const TableHeader = props => {
  let { align } = props;

  return (
    <div className={`col-2 text-${align}`}>
      <b {...props} />
    </div>
  );
};

const TableHead = props => {

  return (
    <>
      <div className="container-fluid" {...props} />
      <hr />
    </>
  );
};


const BlockQuote = props => {
  return (
    <>
      <div className="text-secondary ml-5 mr-5" {...props} />
    </>
  )
}